<template>
  <div class="container">
    <div class="have-equipment">
      <nav-bar leftName="返回" rightShow="false" @leftClick="leftClick()"></nav-bar>
      <div class="canlender"></div>
      <button class="btn btn-block" @click="switchOver()">{{text}}</button>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
// import wx from 'weixin-js-sdk'
// import Common from '../../assets/js/common.js'
import NavBar from '../../components/NavBar/NavBar.vue'
// var api = process.env.BASE_URL
export default {
  components: {
    NavBar
  },
  data () {
    return {
      price: this.$route.query.price,
      text: '应用'
    }
  },
  methods: {
    leftClick () {
      this.$router.replace({path: '/CutStyle'})
    },
    initText () {
      if (this.price !== '') {
        this.text = '收费：' + this.price
      } else {
        this.text = '应用'
      }
    },
    switchOver () {
      if (this.price !== '') {
        /* let _this = this
        if (typeof WeixinJSBridge == 'undefined'){
          if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady, false)
          } else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady)
              document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady)
          }
        }else{
          thid.onBridgeReady();
        } */
      }
    },
    onBridgeReady () {
      /* WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': '', // 公众号名称，由商户传入
          'timeStamp': '', // 时间戳，自1970年以来的秒数
          'nonceStr': '', // 随机串
          'package': '',
          'signType': '', // 微信签名方式
          'paySign': '' // 微信签名
        },
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      ) */
    }
  },
  beforeMount () {
    this.initText()
  }
}
</script>
<style lang="stylus" scoped>
.have-equipment
  .btn
    position absolute;
    bottom 5px;
    width calc(100% - 30px);
    left 15px;
</style>


// WEBPACK FOOTER //
// src/pages/ChanelPreview/ChanelPreview.vue